import React, { useState, useEffect, useMemo } from "react"
import Pagination from '../../pages/paginations'
import { Add } from './Add'
import { Edit } from './Edit'
import axiosJWT from '../../JwtToken'

function View() {
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)
    const [data, setData] = useState([])
    const [rowID, setRowID] = useState(false)
    const [add, setAdd] = useState(false)
    const [edit, setEdit] = useState(false)
    const [confirmBatal, setConfirmBatal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showModalCert, setShowModalCert] = useState(false)
    const [certUrl, setCertUrl] = useState("")

    useEffect(() => {
        getData('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Kasih parameter idUID biar gak nunggu state userID yang lambat
    const getData = async (key) => {
        try {
            const response = await axiosJWT.post("/api/csr/portal/realisasi", {
                key: key
            })
            setData(response.data)
            setCurrentPage(1)
        } catch (err) {
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                || 'Gagal mengambil data kemitraan.'
            setMsg(errorMsg)
            // Gak usah panggil getPesan() di sini biar gak ganggu input pencarian
        }
    }

    const openCert = (url) => {
        setCertUrl(url)
        setShowModalCert(true)
    }

    const triggerBatal = (id) => {
        setTargetID(id)
        setConfirmBatal(true)
    }

    const prosesBatal = async () => {
        try {
            const response = await axiosJWT.delete(`/api/csr/portal/realisasi/${targetID}`)

            setConfirmBatal(false) // Tutup modal konfirmasi
            setMsg(response.data.msg || "PENGAJUAN BERHASIL DIBATALKAN")
            setPesan(true) // Buka modal notifikasi sukses

            await getData('')
            setTimeout(() => setPesan(false), 2000)
        } catch (err) {
            setConfirmBatal(false)
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg : "GAGAL MEMBATALKAN"
            setMsg(errorMsg)
            setPesan(true)
            setTimeout(() => setPesan(false), 3000)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    const getPesan = () => setPesan((prevState) => !prevState)
    const openAdd = (id) => {
        setAdd(true)
    }
    const closeAdd = () => {
        setAdd(false)
    }

    const openEdit = (id) => {
        setRowID(id)
        setEdit(true)
    }
    const closeEdit = () => {
        setRowID(null)
        setEdit(false)
    }

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-body p-5">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-2 col-xs-4">
                                <button onClick={openAdd} className="btn btn btn-raised btn-primary br-2 no-m">
                                    <i className="fa fa-plus"></i> Lapor TJSL/CSR
                                </button>
                            </div>
                            <div className="col-md-10 col-xs-8">
                                <input type="text" className="form-control" placeholder="Cari TJSL/CSR Anda..." onChange={(e) => getData(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-nomargin dataTable table-bordered data">
                            <thead>
                                <tr className="purple">
                                    <th className="text-center">No</th>
                                    <th>TJSL/CSR</th>
                                    <th>Kecamatan</th>
                                    <th>Nilai TJSL/CSR</th>
                                    <th className="text-center">Status</th>
                                    <th className="text-center">Update</th>
                                    <th className="text-center">Sertifikat</th>
                                    <th className="text-center">Batal</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.length > 0 ? tableData.map((row, i) => (
                                    <tr key={row._id}>
                                        <td className="text-center">{(currentPage - 1) * PageSize + (i + 1)}</td>
                                        <td>
                                            <span className="font-bold color-primary">{row.nama_program}</span><br />
                                            <small className="text-muted">{row.kategori}</small>
                                        </td>
                                        <td><small>{row.kecamatan_csr}</small></td>
                                        <td>
                                            <b>Rp {new Intl.NumberFormat('id-ID').format(
                                                (row.nilai_realisasi > 0) ? row.nilai_realisasi : (row.nilai_csr || 0)
                                            )}</b>
                                        </td>
                                        <td className="text-center">
                                            {/* Visual Badge yang lebih informatif buat Mitra */}
                                            {row.status_realisasi === 'Pengajuan' && <span className="badge d-inline-block text-wrap badge-warning">Menunggu Verifikasi</span>}
                                            {row.status_realisasi === 'Disetujui' && <span className="badge d-inline-block text-wrap badge-info">Disetujui Admin</span>}
                                            {row.status_realisasi === 'Pengerjaan' && <span className="badge d-inline-block text-wrap badge-primary">Sedang Berjalan</span>}
                                            {row.status_realisasi === 'Selesai' && <span className="badge d-inline-block text-wrap badge-success">Selesai / BAST</span>}
                                            {row.status_realisasi === 'Dibatalkan' && <span className="badge d-inline-block text-wrap badge-danger">Dibatalkan</span>}
                                            {row.status_realisasi === 'Ditolak' && <span className="badge d-inline-block text-wrap label-default" style={{ background: '#000' }}>Ditolak</span>}
                                        </td>
                                        <td className="text-center">
                                            {/* 1. Kondisi: Masih bisa Update (Progres belum final) */}
                                            {['Disetujui', 'Pengerjaan'].includes(row.status_realisasi) ? (
                                                <button onClick={() => openEdit(row._id)} className="btn btn-raised btn-success br-2 no-m">
                                                    <i className="fa fa-refresh no-m"></i> Update
                                                </button>
                                            ) : (
                                                /* 2. Kondisi: Sudah Selesai/Final (Tetep bisa lihat detail, tapi labelnya 'Detail') */
                                                <button onClick={() => openEdit(row._id)} className="btn btn-raised btn-primary br-2 no-m">
                                                    <i className="fa fa-search no-m"></i> Detail
                                                </button>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            {row.status_realisasi === 'Selesai' && row.file_sertifikat_csr ? (
                                                <button
                                                    onClick={() => openCert(row.file_sertifikat_csr)}
                                                    className="btn btn-raised btn-info br-2 no-m"
                                                >
                                                    <i className="fa fa-file-pdf-o"></i> Lihat Sertifikat
                                                </button>
                                            ) : (
                                                <span className="text-muted"><i className="fa fa-lock"></i></span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            {/* BATAL: Cuma muncul kalau masih 'Pengajuan' sesuai gembok di Backend */}
                                            {row.status_realisasi === 'Pengajuan' ? (
                                                <button onClick={() => triggerBatal(row._id)} className="btn btn-raised btn-danger br-2 no-m">
                                                    <i className="fa fa-remove no-m"></i>
                                                </button>
                                            ) : (
                                                <span className="text-muted">-</span>
                                            )}
                                        </td>
                                    </tr>
                                )) : (
                                    <tr><td colSpan="7" className="text-center p-5">Belum ada program kemitraan yang Anda ambil.</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="form-group mt-3">
                        <div className="row">
                            <div className="col-md-4 col-xs-6">
                                Total: <b>{data.length}</b> Program Kemitraan
                            </div>
                            <div className="col-md-8 col-xs-6">
                                <Pagination className="pagination-bar text-right" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {add && (
            <div className="modal-open">
                <div style={{ display: add ? "block" : "none" }} className={add ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center">Laporan TJSL/CSR</h4>
                            </div>
                            <div className="modal-body">
                                <Add getData={() => getData('')} closeAdd={closeAdd} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}

        {edit && (
            <div className="modal-open">
                <div style={{ display: edit ? "block" : "none" }} className="modal modal-primary show" tabIndex="-1">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center">Lengkapi Dokumen TJSL/CSR</h4>
                            </div>
                            <div className="modal-body">
                                <Edit getData={() => getData('')} rowID={rowID} closeEdit={closeEdit} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}

        {showModalCert && (
            <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
        )}

        {/* MODAL PREVIEW SERTIFIKAT - Bungkus pake modal-open biar CSS template lu nangkep */}
        {showModalCert && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-primary p-1">
                                <button type="button" className="close no-p" onClick={() => setShowModalCert(false)} style={{ color: '#fff', opacity: 1 }}>&times;</button>
                                <h4 className="modal-title no-p"><i className="fa fa-certificate"></i> Preview Sertifikat TJSL/CSR</h4>
                            </div>
                            <div className="modal-body p-0" style={{ height: '50vh', overflow: 'hidden', backgroundColor: '#525659' }}>
                                {certUrl ? (
                                    <iframe src={`${certUrl}#toolbar=1&navpanes=0&scrollbar=1`} width="100%" height="100%" frameBorder="0" title="File TJSL/CSR"></iframe>
                                ) : (
                                    <div className="p-5 text-center text-white">Memuat dokumen...</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowModalCert(false)}>Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}

        {confirmBatal && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1050 }}>
                    <div className="modal-dialog center">
                        <div className="modal-content modal-sm">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center font-bold">KONFIRMASI</h4>
                            </div>
                            <div className="modal-body text-center">
                                <p>Apakah Anda yakin ingin membatalkan pengajuan ini?</p>
                                <hr />
                                <button onClick={prosesBatal} className="btn btn-danger btn-raised btn-sm mr-2">YA, BATALKAN</button>
                                <button onClick={() => setConfirmBatal(false)} className="btn btn-default btn-raised btn-sm">TIDAK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
            </div>
        )}

        <div className={pesan ? "modal-open" : ""}>
            <div style={{ display: pesan ? "block" : "none" }} className={pesan ? "modal modal-primary show" : "modal modal-primary"}>
                <div className="modal-dialog center">
                    <div className="modal-content modal-sm">
                        <div className="modal-header header-modal-primary p-1">
                            <h4 className="modal-title text-center font-bold">NOTIFIKASI</h4>
                        </div>
                        <div className="modal-body text-center">
                            <h4 className="font-bold">{msg.toUpperCase()}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>)
}

export default View